import { useEffect, useState } from 'react';
import { Trophy } from 'lucide-react';
import { api } from '../../lib/api';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChampionsStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await api.tournaments('completed');
        const completed = (d.tournaments || []).slice(0, 6);
        const results = await Promise.all(
          completed.map((t) =>
            axios
              .get(`${API}/tournaments/${t.id}/results`)
              .then((r) => r.data.winners || [])
              .catch(() => [])
          )
        );
        if (!alive) return;
        const out = [];
        completed.forEach((t, i) => {
          const w = results[i] || [];
          if (w[0]?.team) out.push({ team: w[0].team, title: t.title });
        });
        setItems(out);
      } catch {
        if (alive) setItems([]);
      }
    };
    load();
    const i = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(i);
    };
  }, []);

  if (!items.length) return null;

  const loop = [...items, ...items, ...items, ...items];

  return (
    <div className="bg-[#141824] border-y border-[#ffd700]/15 overflow-hidden py-2 relative z-10" data-testid="champions-strip">
      <div className="animate-marquee flex w-max items-center" style={{ animationDuration: '46s' }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {loop.map((it, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <Trophy className="w-3.5 h-3.5 text-[#ffd700] ml-8 shrink-0" />
                <span className="text-[#ffd700] text-[11px] font-extrabold uppercase tracking-[0.18em] px-2.5 whitespace-nowrap">
                  {it.team}
                </span>
                <span className="text-[#8a8a8a] text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap">
                  — {it.title}
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
